export const RouteConstants = {
  Stats: 'stats',
  Account: 'account',
  MatchHistory: 'matchHistory',
  MatchDetails: 'matchDetails'
}
